import { render, staticRenderFns } from "./Spinners.vue?vue&type=template&id=5745105c&scoped=true&"
import script from "./Spinners.vue?vue&type=script&lang=ts&"
export * from "./Spinners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5745105c",
  null
  
)

export default component.exports